<ng-template [appTopbarTemplate]>
  <div class="title">
    <div class="row align-items-center">
      <div class="col col-shrink">
        <h4 class="mb-0 oneline d-inline">{{ project?.Name }}&nbsp;</h4>
        <span class="small">{{ texts.genderSuffix | localize }}</span>
      </div>
      <div class="col-auto">
        <app-status-badge-project class="ms-3" [project]="project"></app-status-badge-project>
      </div>
    </div>
  </div>
  <div class="nav">
    <ul class="nav nav-tabs nav-overflow">
      <li class="nav-item"><a class="nav-link" (click)="activateView('base')" [class.active]="view == 'base'">{{ texts.tabs.base | localize }}</a></li>
      <li class="nav-item"><a class="nav-link" (click)="activateView('analysis')" [class.active]="view == 'analysis'">{{ texts.tabs.analysis | localize }}</a></li>

      @if (project?.Type == 'Longlist')
      {
      <li class="nav-item"><a class="nav-link" (click)="activateView('ident')" [class.active]="view == 'ident'">Ident</a></li>
      @if (demo.isActive)
      {
      <li class="nav-item"><a class="nav-link" (click)="activateView('pool')" [class.active]="view == 'pool'">Pool</a></li>
      }
      }
      @else
      {
      <li class="nav-item"><a class="nav-link" (click)="activateView('outreach')" [class.active]="view == 'outreach'">{{ texts.tabs.outreach | localize }}</a></li>

      <li class="nav-item"><a class="nav-link" (click)="activateView('applications')" [class.active]="view == 'applications'">{{ texts.tabs.applications | localize }}</a></li>
      
      @if (demo.isActive)
      {
      <li class="nav-item"><a class="nav-link" (click)="activateView('pool')" [class.active]="view == 'pool'">Pool</a></li>
      }
      }

    </ul>
  </div>
  <div class="actions" *ngIf="project">
    <button *ngIf="project.Status == 'AwaitingOrder' || project.Status == 'Imported' || project.Status == 'AnalysisRequested'" class="btn btn-dark btn-sm" (click)="startModal.show(project)">{{ texts.startSourcing | localize }} <i
        class="fa-sharp fa-solid fa-arrow-right ms-2"></i></button>
    <button disabled *ngIf="project.Status == 'AwaitingSourcing' || project.Status == 'Sourcing'" class="btn btn-dark btn-sm">
      <i class="fa-sharp fa-solid fa-check me-2"></i> {{ texts.startedSourcing | localize }} </button>
      <button disabled *ngIf="project.Status == 'Completed'" class="btn btn-dark btn-sm">
      <i class="fa-sharp fa-solid fa-check me-2"></i> {{ texts.completed | localize }} </button>
  </div>
</ng-template>

<div class="scroll-dummy" *ngIf="!project"></div>

<div class="content" [@fadeIn]="state">

  <div class="container" *ngIf="notifications">
    <div class="row">
      <div class="col-12">
        <app-notification-project [items]="notifications" [project]="project"
          [language]="loc.language"></app-notification-project>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col-12">

        <app-content-loading *ngIf="!project"></app-content-loading>

        <app-project-base *ngIf="view == 'base'" [project]="project"
          (start)="startModal.show(project)"></app-project-base>

        <app-project-analysis *ngIf="view == 'analysis'" [project]="project"></app-project-analysis>

        <app-project-pool *ngIf="view == 'pool'" [project]="project"></app-project-pool>

        <app-project-ident *ngIf="view == 'ident'" [project]="project"></app-project-ident>

        <app-project-outreach *ngIf="view == 'outreach'" [project]="project"></app-project-outreach>

        <app-project-applications *ngIf="view == 'applications'" [project]="project"></app-project-applications>

      </div>

    </div>
  </div>
</div>

<app-modal-start-project #startModal [language]="loc.language"></app-modal-start-project>